import { Box, Button, Stack, Typography } from '@mui/material';
import { ConfirmAndCancel, TStepContent } from '@verifime/components';
import tokens from '@verifime/design-tokens';
import { ReactNode } from 'react';

export default function StepWrapper({
  title,
  content,
  onBack,
  onNext,
  step,
  header,
  footer,
}: {
  title?: string;
  content: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
} & TStepContent) {
  if (!title && !header) {
    throw new Error('Please given title or header');
  }

  const footerNode = footer ?? (
    <ConfirmAndCancel
      cancel={
        <>
          {step === 'first' || step === 'both' ? (
            <Box />
          ) : (
            <Button
              fullWidth
              variant="outlined"
              size="large"
              onClick={onBack}
              data-action="step-back"
            >
              Back
            </Button>
          )}
        </>
      }
      confirm={
        <>
          {step !== 'last' && step !== 'both' && (
            <Button
              fullWidth
              variant="contained"
              size="large"
              onClick={onNext}
              data-action="step-continue"
            >
              continue
            </Button>
          )}
        </>
      }
    />
  );

  return (
    <Stack
      direction="column"
      sx={{
        marginTop: tokens.spacing3xl,
        gap: tokens.spacingXl,
        // Mobile padding adjustment: removes horizontal padding on desktop
        // to allow full-width content within StepWrapper container
        px: [tokens.spacingBase, 0],
      }}
      data-component="step-wrapper"
    >
      {header ?? (
        <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
          <Typography variant="h4">{title}</Typography>
        </Stack>
      )}
      <Stack direction="column">{content}</Stack>
      {footerNode}
    </Stack>
  );
}
